import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconArrowsRepeatCircle } from '~/ui/core/icons';

import { StatusIndicator } from './StatusIndicator';

export const NewVersionBadge: FunctionComponent = () => {
    const translate = useTranslate();

    return (
        <StatusIndicator
            className="text-orange-800"
            data-testid="review-state-new-version"
            icon={<IconArrowsRepeatCircle size={12} />}
        >
            {translate('pages.job-architecture-v2.review-state.new-version')}
        </StatusIndicator>
    );
};
